import styled from "styled-components";

export const Container = styled.main`
  section{
    button{
      width: 100%;
      height: 46px;
      border-radius: 6px;
    }
  }

  @media screen and (min-width: 501px) {
    section{
      width: 360px;
      margin: 0 auto;
    }

  }

  @media (max-width: 500px) {
    section{
      width: 100%;
    }
  }
`